import { APIConfig } from '../config/APIConfig';
import { buildApiUrl } from '../../config/environment';

export interface DayObservation {
  id: string;
  date: string;
  title: string;
  description: string | null;
  category: string;
  color: string;
  created_by: string;
  created_at: string;
}

export interface DayObservationCreate {
  date: string;
  title: string;
  description?: string;
  category: string;
}

export interface DayObservationUpdate {
  /** Permite remarcar a observação (drag & drop no calendário). */
  date?: string;
  title?: string;
  description?: string;
  category?: string;
}

export interface ObservationCategory {
  value: string;
  label: string;
  color: string;
}

export class DayObservationService {
  static async list(startDate?: string, endDate?: string): Promise<DayObservation[]> {
    const params = new URLSearchParams();
    if (startDate) params.append('start_date', startDate);
    if (endDate) params.append('end_date', endDate);
    const qs = params.toString();
    const url = buildApiUrl(`/api/v1/day-observations${qs ? `?${qs}` : ''}`);
    const response = await APIConfig.getInstance().get<DayObservation[]>(url);
    return response.data;
  }

  static async create(data: DayObservationCreate): Promise<DayObservation> {
    const url = buildApiUrl('/api/v1/day-observations');
    const response = await APIConfig.getInstance().post<DayObservation>(url, data);
    return response.data;
  }

  static async update(id: string, data: DayObservationUpdate): Promise<DayObservation> {
    const url = buildApiUrl(`/api/v1/day-observations/${id}`);
    const response = await APIConfig.getInstance().put<DayObservation>(url, data);
    return response.data;
  }

  static async delete(id: string): Promise<void> {
    const url = buildApiUrl(`/api/v1/day-observations/${id}`);
    await APIConfig.getInstance().delete(url);
  }

  static async getCategories(): Promise<ObservationCategory[]> {
    const url = buildApiUrl('/api/v1/day-observations/categories');
    const response = await APIConfig.getInstance().get<ObservationCategory[]>(url);
    return response.data;
  }
}
